var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPropertysafety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "propertysafety-filled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-307.000000, -306.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "propertysafety-filled",
    transform: "translate(307.000000, 306.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3179688,3.98203125 L12.3539063,1.26796875 C12.2578125,1.23515625 12.1289063,1.21875 12,1.21875 C11.8710938,1.21875 11.7421875,1.23515625 11.6460938,1.26796875 L3.68203125,3.98203125 C3.4875,4.04765625 3.328125,4.27265625 3.328125,4.47890625 L3.328125,15.7851562 C3.328125,15.9914062 3.46171875,16.2632812 3.6234375,16.3921875 L11.7023438,22.6875 C11.784375,22.7507813 11.8898438,22.7835938 11.9976563,22.7835938 C12.1054688,22.7835938 12.2132813,22.7507813 12.2929688,22.6875 L20.371875,16.3921875 C20.5335938,16.265625 20.6672883,15.99375 20.6672883,15.7851562 L20.6672883,4.47890625 C20.671875,4.27265625 20.5125,4.05 20.3179688,3.98203125 Z M15.1945313,7.8 L13.1390625,11.5757812 L14.2101562,11.5757812 C14.3390625,11.5757812 14.4445312,11.68125 14.4445312,11.8101562 L14.4445312,12.309375 C14.4445312,12.4382812 14.3390625,12.54375 14.2101562,12.54375 L12.7242187,12.54375 L12.7242187,13.2398437 L14.2101562,13.2398437 C14.3390625,13.2398437 14.4445312,13.3453125 14.4445312,13.4742187 L14.4445312,13.9734375 C14.4445312,14.1023437 14.3390625,14.2078125 14.2101562,14.2078125 L12.7242187,14.2078125 L12.7242187,15.421875 C12.7242187,15.5507812 12.61875,15.65625 12.4898438,15.65625 L11.521875,15.65625 C11.3929687,15.65625 11.2875,15.5507812 11.2875,15.421875 L11.2875,14.2078125 L9.80859375,14.2078125 C9.6796875,14.2078125 9.57421875,14.1023437 9.57421875,13.9734375 L9.57421875,13.4742188 C9.57421875,13.3453125 9.6796875,13.2398438 9.80859375,13.2398438 L11.2875,13.2398438 L11.2875,12.54375 L9.80859375,12.54375 C9.6796875,12.54375 9.57421875,12.4382812 9.57421875,12.309375 L9.57421875,11.8101562 C9.57421875,11.68125 9.6796875,11.5757812 9.80859375,11.5757812 L10.8679687,11.5757812 L8.80546875,7.8 C8.74453125,7.6875 8.784375,7.54453125 8.89921875,7.48125 C8.934375,7.4625 8.971875,7.453125 9.01171875,7.453125 L10.0898438,7.453125 C10.1789062,7.453125 10.2585937,7.50234375 10.2984375,7.58203125 L12.0070312,10.9640625 L13.7226562,7.58203125 C13.7625,7.50234375 13.8445313,7.453125 13.93125,7.453125 L14.9859375,7.453125 C15.1148438,7.453125 15.2203125,7.55859375 15.2203125,7.6875 C15.2226562,7.72734375 15.2132813,7.76484375 15.1945313,7.8 Z",
    id: "\\u5F62\\u72B6"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertysafety);
export default __webpack_public_path__ + "static/media/propertysafety.ee64ce92f23bfc5830228a2a07330b57.svg";
export { ForwardRef as ReactComponent };